var _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBrandSm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 32C7.16344 32 -1.08564e-06 24.8366 -6.99382e-07 16C-3.13124e-07 7.16344 7.16344 -1.08564e-06 16 -6.99382e-07C24.8366 -3.13124e-07 32 7.16344 32 16C32 24.8366 24.8366 32 16 32ZM16 7.6375C11.3815 7.6375 7.6375 11.3815 7.6375 16C7.6375 20.6185 11.3815 24.3625 16 24.3625C20.6185 24.3625 24.3625 20.6185 24.3625 16C24.3625 11.3815 20.6185 7.6375 16 7.6375Z",
    fill: "url(#paint0_linear_504_22)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 1.90798e-07C18.5445 2.21141e-07 21.0524 0.60688 23.3154 1.77027C25.5784 2.93366 27.5313 4.62001 29.012 6.68935C30.4927 8.75869 31.4585 11.1513 31.8292 13.6687C32.2 16.1861 31.965 18.7556 31.1438 21.164C30.3225 23.5723 28.9387 25.7501 27.1072 27.5165C25.2757 29.2829 23.0493 30.5871 20.6128 31.3206C18.1763 32.0542 15.6 32.1961 13.0977 31.7346C10.5953 31.273 8.23919 30.2213 6.22476 28.6667L10.8961 22.6136C11.9479 23.4253 13.1781 23.9744 14.4846 24.2154C15.7911 24.4564 17.1363 24.3823 18.4085 23.9993C19.6806 23.6163 20.8431 22.9354 21.7994 22.0131C22.7556 21.0908 23.4782 19.9537 23.9069 18.6962C24.3357 17.4388 24.4584 16.0972 24.2649 14.7828C24.0713 13.4684 23.567 12.2191 22.7939 11.1387C22.0208 10.0582 21.0011 9.17773 19.8195 8.57029C18.638 7.96286 17.3286 7.64599 16 7.64599L16 1.90798e-07Z",
    fill: "url(#paint1_linear_504_22)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_504_22",
    x1: 32,
    y1: 16,
    x2: -6.99382e-7,
    y2: 16,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D0F8EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#25CBA1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_504_22",
    x1: 8.63878,
    y1: 34.8593,
    x2: 28.1673,
    y2: 1.76426,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#49D4B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.779417,
    stopColor: "#15715A"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrandSm);
export default __webpack_public_path__ + "static/media/brand-sm.43ce579648a4c89355a815abdd761d65.svg";
export { ForwardRef as ReactComponent };